module.exports = "<div *ngIf=\"isShow\" class=\"home-topbanner-container\"\n  [ngStyle]=\"{'background-image': 'url(' + (isMobile ? banner.mobileImage : banner.image) + ')'}\"\n  >\n  <div class=\"topbanner-wrapper\">\n    <p i18n class=\"topbanner-title\">{{banner.title}}</p>\n    <a *ngIf=\"banner.url\" class=\"btn-wrap-banner\"  href=\"{{banner.url}}\" target=\"${banner.newWindow === 'true' ? '_blank' : '_self'}\">\n      {{banner.linkName}}\n    </a>\n  </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/top-banner/top-banner.component.html
// module id = 1089
// module chunks = 0